import { Component } from "react";
import autoBind from "react-autobind";
import { withRouting } from "@/components/shared/withRouting";
import { VendorUtilities } from "../../utilities/VendorUtilities";

import Footer from "../shared/Footer";
import Alert from "../shared/Alert";

import { Button } from "../shared/Button";
import TextInput from "../shared/TextInput";

class AccountLocked extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailError: false,
      emailMessage: ""
    };
    autoBind(this);
  }

  clearErrors = () => {
    this.setState({
      emailError: false,
      emailMessage: ""
    });
  };

  handleFormChange = (field, value) => {
    if (this.state.emailError) {
      this.clearErrors();
    }
    if (this.props.err) {
      this.props.clearServerError();
    }
    let nextState = {};
    nextState[field] = value;
    this.setState(nextState);
  };

  buildPayload = () => {
    return {
      email: this.state.email.trim()
    };
  };

  validateFields = () => {
    if (!VendorUtilities.isEmailValid(this.state.email)) {
      this.setState({
        emailError: true,
        emailMessage: "Please use a valid email address"
      });
      return false;
    }
    return true;
  };

  onSubmit = e => {
    e.preventDefault();
    this.clearErrors();
    const payload = this.buildPayload();
    const canSubmit = this.validateFields();
    if (canSubmit) {
      this.props.sendAccountUnlockEmail(payload);
    }
  };

  componentDidMount() {
    this.props.clearServerError();
    const searchParams = new URLSearchParams(this.props.location.search);
    const emailParam = searchParams.get("email");
    if (emailParam) {
      this.setState({ email: emailParam });
    }
  }

  render() {
    const { dataLoading } = this.props;

    return (
      <div className="h-full w-full flex flex-col overflow-y-auto">
        <div className="block min-[800px]:flex min-[800px]:flex-row flex-auto w-full">
          <div className="flex flex-1 flex-col items-center self-center mx-auto max-lg:mb-[70px] lg:flex lg:flex-col">
            <div className="relative bg-[top_center] bg-[url('../../images/global/replicated-logo-red.svg')] bg-no-repeat bg-[length:350px] w-[586px] h-[180px] mt-[70px] max-lg:static max-lg:bg-[length:250px] max-lg:w-full max-lg:h-[100px] max-lg:!h-[60px]"></div>
          </div>

          <div className="bg-page-bg lg:ml-0 lg:text-left flex-1 min-h-0 flex flex-col items-center justify-center pb-3 auth-pages">
            {this.props.accountUnlockStep === "success" ? (
              <div className="w-full max-w-[400px] mx-auto max-[430px]:w-[90%] lg:mx-0">
                <p className="text-[42px] font-light text-gray-800 leading-[1.4]">
                  Account locked
                </p>
                <p className="text-base font-normal text-gray-410 leading-[1.4] mt-3">
                  The unlock email has been sent. Please check your email for the next
                  steps.
                </p>
                <div className="flex mt-5">
                  <div className="FormButton-wrapper flex">
                    <Button
                      kind="secondary-gray"
                      className="mr-3 flex-none mt-2.5 mb-5"
                      onClick={() => this.props.setAccountUnlockStep("info")}
                    >
                      Resend email
                    </Button>
                  </div>
                  <div className="FormButton-wrapper flex">
                    <Button
                      kind="primary-purple"
                      className="flex-none mt-2.5 mb-5"
                      onClick={() => this.props.navigate("/login")}
                    >
                      Back to login
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full max-w-[400px] mx-auto max-[430px]:w-[90%] lg:mx-0">
                <p className="font-['Montserrat',sans-serif] font-bold text-hex-2e96c2 text-[30px] !text-left max-lg:mt-[70px] leading-[1.4]">
                  Account locked
                </p>
                <p className="font-['Open_Sans',sans-serif] text-gray-410 text-base font-normal leading-[1.4] mt-3">
                  Your account has been locked because of too many invalid login
                  attempts. We've done this as a precaution to prevent unauthorized
                  access to your account.
                </p>
                <p className="font-['Open_Sans',sans-serif] text-gray-410 text-base font-normal leading-[1.4] mt-3">
                  To unlock your account, confirm your email address below and click the
                  Send button. You'll receive an email with a link to click to verify
                  you have access to the email address associated with this account.
                </p>
                <div>
                  <form
                    onSubmit={e => {
                      this.onSubmit(e);
                    }}
                  >
                    <div className="FormSection-wrapper">
                      {this.state.emailError ? (
                        <Alert variant="error" className="mb-1.5">
                          {this.state.emailMessage}
                        </Alert>
                      ) : null}
                      {this.props.err ? (
                        <Alert variant="error" className="mb-1.5">
                          {this.props.errMessage}
                        </Alert>
                      ) : null}
                      <div className="mb-3">
                        <TextInput
                          name="email"
                          type="text"
                          placeholder="Email address"
                          value={this.state.email}
                          onChangeValue={value =>
                            this.handleFormChange("email", value)
                          }
                        />
                      </div>
                    </div>
                    <div className="FormButton-wrapper flex">
                      <Button
                        kind="primary-purple"
                        size="small"
                        type="submit"
                        className="flex-none mt-2.5 mb-5 w-full"
                        disabled={
                          dataLoading.accountUnlockEmailLoading ||
                          this.state.email === ""
                        }
                      >
                        {dataLoading.accountUnlockEmailLoading
                          ? "Sending"
                          : "Send validation email"}
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            )}
            <div className="absolute bottom-[10px] right-[10px] !text-gray-200 max-lg:mx-auto max-lg:pt-[10px] max-lg:static max-lg:w-full max-lg:text-center max-lg:min-h-[100px]">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouting(AccountLocked);
